module.exports = __webpack_public_path__ + "media/images/top-91ad5f31.png";